import React, {useState, Fragment, useEffect} from "react";
import {Col, Container, ListGroup, Row} from "react-bootstrap";

function Social() {
    const [social, setSocial] = useState([]);
    const gitLab = process.env.REACT_APP_GITLAB;
    const myemail = process.env.REACT_APP_EMAIL;
    const linkedin = process.env.REACT_APP_LINKEDIN;

    useEffect(() => {
        setSocial({gitlab : gitLab,
                        email : myemail,
                        linkedin : linkedin
        })
    }, [gitLab,myemail,linkedin])

    return (
        <Fragment>
            <section id="signup" className="signup-section">
                <Container key="Social">
                    <Row>
                        <Col></Col>
                        <Col>
                            <ListGroup className="text-center opacity-50 bg-opacity-50 container">
                                <h4 className="mb-4">Réseaux sociaux</h4>
                                <ListGroup.Item>
                                    <a href={`mailto:${social.email}?subject=Prise de contact NvdXavier`} className="list-group-item" target="_blank"  rel="noopener noreferrer">{social.email}</a>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <a href={social.linkedin} className="list-group-item"  target="_blank"  rel="noopener noreferrer">{social.linkedin}</a>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <a href={social.gitlab} className="list-group-item"  target="_blank"  rel="noopener noreferrer">{social.gitlab}</a>
                                </ListGroup.Item>
                            </ListGroup>
                        </Col>
                        <Col></Col>
                    </Row>
                </Container>
            </section>
        </Fragment>
         )
}

export default Social;